module.exports = __webpack_public_path__ + "static/01-69f5b32d9f968b8c8e252a8c35d581b8.png";